import { WidgetType, WidgetConfigurationField, WidgetOptionConfigurationField } from 'domain/entity/widget';
import { Option, none, isNone, some } from 'fp-ts/lib/Option';

export default interface CreateWidgetCriteria {
    dashboardId: string;
    name: string;
    type: WidgetType;
    presetKey: string;
    configurationFields: WidgetConfigurationField[];
    optionFields: WidgetOptionConfigurationField[];
}

class CreateWidgetCriteriaImpl implements CreateWidgetCriteria {
    constructor(
        readonly dashboardId: string,
        readonly name: string,
        readonly type: WidgetType,
        readonly presetKey: string,
        readonly configurationFields: WidgetConfigurationField[],
        readonly optionFields: WidgetOptionConfigurationField[]
    ) {}
}

export class CreateWidgetCriteriaBuilder {
    private dashboardId: Option<string> = none;

    private name: Option<string> = none;

    private type: Option<WidgetType> = none;

    private presetKey: Option<string> = none;

    private configurationFields: Option<WidgetConfigurationField[]> = none;

    private optionFields: Option<WidgetOptionConfigurationField[]> = none;

    static create = (): CreateWidgetCriteriaBuilder => new CreateWidgetCriteriaBuilder();

    withDashboardId = (dashboardId: string): CreateWidgetCriteriaBuilder => {
        this.dashboardId = some(dashboardId);
        return this;
    };

    withName = (name: string): CreateWidgetCriteriaBuilder => {
        this.name = some(name);
        return this;
    };

    withType = (type: WidgetType): CreateWidgetCriteriaBuilder => {
        this.type = some(type);
        return this;
    };

    withPresetKey = (presetKey: string): CreateWidgetCriteriaBuilder => {
        this.presetKey = some(presetKey);
        return this;
    };

    withConfigurationFields = (configurationFields: WidgetConfigurationField[]): CreateWidgetCriteriaBuilder => {
        this.configurationFields = some(configurationFields);
        return this;
    };

    withOptionFields = (optionFields: WidgetOptionConfigurationField[]): CreateWidgetCriteriaBuilder => {
        this.optionFields = some(optionFields);
        return this;
    };

    build = (): CreateWidgetCriteria => {
        if (
            isNone(this.dashboardId) ||
            isNone(this.name) ||
            isNone(this.type) ||
            isNone(this.presetKey) ||
            isNone(this.configurationFields) ||
            isNone(this.optionFields)
        ) {
            throw new ReferenceError('Undefined prop');
        }

        return new CreateWidgetCriteriaImpl(
            this.dashboardId.value,
            this.name.value,
            this.type.value,
            this.presetKey.value,
            this.configurationFields.value,
            this.optionFields.value
        );
    };
}
